import React, { Component } from "react";
import { connect } from "react-redux";
import Pagination from "@material-ui/lab/Pagination";
import { Row, Col, Container } from "reactstrap";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { NotificationManager } from "react-notifications";
import * as FileSaver from "file-saver";
import GetAppIcon from "@material-ui/icons/GetApp";
//actions
import {
  getLocations,
  getLocationsExcel,
  createLocationViaExcel,
} from "../../store/baxter_location/actions";
import {
  fetchLocationPresignedUrl,
  uploadImagesAws,
} from "../../store/baxter-uploadModule/actions";
// component
import { WaveLoader } from "../../components/Common/Loader/LoaderIndex";
import Index from "../../components/Common/DataTableNeo/Index";
import {
  AdminHeaderData,
  getLocalStorage,
  searchBar,
} from "./RowHeaders/RowHeaders";
import QuickFilters from "./quckFilters";
import { exportToCSV } from "../common/exportToCsv";

var totCnt = 0;
var totPages = 0;
var toVal = 0;
var fromVal = 0;
var offset = 0;
var darkTheme;
var searchValues = {};
class Location extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      dataLoading: false,
      loadingForExcel: false,
      offset: 0,
      isOpen: false,
      selectedFile: "",
      excelUrl: "",
      searchFilters: {},
    };
    this.fileInput = React.createRef();

    // (async () => {
    //   let redirect = await restrict(PERMS.DRIVER_TRANSPORTER_READ);

    //   if (redirect === false) {
    //     this.props.history.push("/operationsDashboard");
    //   }
    // })();

    // this.handleInputDebounceName = debounce(this.getDriverNameFunc, 1000);
    // this.handleInputDebouncePhone = debounce(this.getDriverPhoneFunc, 1000);
  }
  fileUploadTrigger = () => {
    this.fileInput.current.click();
  };
  componentDidMount() {
    // let mountFilterData = window.localStorage.getItem("locationFilterData") ? JSON.parse(window.localStorage.getItem("locationFilterData")) : "";
    // searchValues = mountFilterData || {}
    // console.log(mountFilterData,searchValues,"98")
    if (this.props.location?.state?.filter !== undefined) {
      let filters = this.props.location.state.filter;
      this.setState({ searchFilters: searchValues }, () => {
        offset = 0;
        window.localStorage.setItem(
          "locationFilterData",
          JSON.stringify(this.state.searchFilters)
        );
        window.localStorage.setItem("locationOffset", offset);
        this.getAllData();
      });
    } else {
      offset = 0;
      this.getAllData();
    }
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
  }
  resize() {
    if (window.innerWidth <= 1500)
      this.setState({ zoomVal: 0.8 }, () => {
        document.body.style.zoom = this.state.zoomVal;
      });
    else document.body.style.zoom = 0.9;
  }
  getAllData = () => {
    this.setState({ dataLoading: true }, () => {});
    let searchFilters = this.state.searchFilters;
    this.props.getLocations(
      {
        offset: offset,
        limit: 10,
        ...searchFilters,
      },
      () => {
        this.setState({ dataLoading: false });
      }
    );
  };
  handleChangePage = (event, val) => {
    // console.log(event, val, "handlepage");
    offset = (val - 1) * process.env.REACT_APP_PERPAGE;
    this.setState({ loading: true });
    this.getAllData();
  };
  fileUpload = (event) => {
    this.setState(
      {
        selectedFile: event.target.files[0],
      },
      () => {
        this.S3Upload();
      }
    );
  };
  S3Upload = async () => {
    this.props.fetchLocationPresignedUrl((res) => {
      // console.log("res", res.presignedS3Url);
      let softCopy = "";
      softCopy = res.presignedS3Url.split("?")[0];
      // console.log("SoftCopy", softCopy);
      this.setState(
        {
          excelUrl: softCopy,
        },
        () => {
          // console.log("images", this.state.images);
          const formData = new FormData();
          formData.append(
            this.state.selectedFile,
            this.state.selectedFile.name
          );
          // console.log("--------", formData);
          const myHeaders = new Headers();
          myHeaders.append("Content-Type", this.state.selectedFile.type);
          this.props.uploadImagesAws(
            res.presignedS3Url,
            this.state.selectedFile,
            myHeaders
          );
        }
      );
    });
  };
  handleSubmitExcel = () => {
    // if(this.state.excelUrl){
    this.setState({
      loadingForExcel: true,
    });
    // console.log("excelUrl", this.state.excelUrl);
    this.props.createLocationViaExcel(
      { excelFileURL: this.state.excelUrl },
      (res) => {
        if (res.success) {
          this.setState({
            loadingForExcel: false,
          });
          NotificationManager.success(res["message"], "Success");
          this.getAllData();
          this.closeModal();
        } else {
          NotificationManager.error(res["message"], "Error");
        }
      }
    );
    // }
  };
  handledownloadTemplate = () => {
    let userUploadTemplate =
      "https://baxterfiles.s3.ap-south-1.amazonaws.com/08-11-2023/location_master/main/LOCATION_MASTER/0b469871-774f-4cb5-b9ad-dafc7e0c089a_d1b98a18-7907-4187-a1b3-eb188b88b768.vnd.ms-excel";
    let filename = "Location Upload Template.xlsx";
    FileSaver.saveAs(userUploadTemplate, filename);
  };

  openModal = () => {
    this.setState({
      isOpen: true,
    });
  };
  closeModal = () => {
    this.setState({
      isOpen: false,
      excelUrl: "",
    });
  };
  reset = () => {
    localStorage.removeItem("locationFilterData");
    localStorage.removeItem("locationOffset");
    offset = 0;
    searchValues = {};
    this.setState({ searchFilters: {} }, () => {
      this.getAllData();
    });
  };
  searchValueAssignerFunction = (name, value, type) => {
    // console.log(name, value, type, "tested");
    if (typeof value === "text" || type === "text") {
      offset = 0;
      window.localStorage.setItem("locationOffset", offset);
      searchValues[name] = value?.toUpperCase();
      this.setState({ searchFilters: searchValues }, () => {
        window.localStorage.setItem(
          "locationFilterData",
          JSON.stringify(this.state.searchFilters)
        );
        window.localStorage.setItem("locationOffset", offset);
      });
    }
  };

  exportExcelData = () => {
    this.setState({ dataLoading: true }, () => {});
    let searchFilters = this.state.searchFilters;
    this.props.getLocationsExcel(
      {
        offset: 0,
        limit: 100000,
        ...searchFilters,
      },
      (res) => {
        this.setState({ dataLoading: false }, () => {});
        // this.setState({ isExportingExcel: false });
        // let exdata=[]
        let exportData = [];
        if (res?.data?.docs?.length > 0) {
          res.data.docs.map((ele) => {
            // console.log("ele", ele);
            exportData.push({
              "Address Line 1": ele?.addressLine1,
              "Address Line 2": ele?.addressLine2,
              "Address Line 3": ele?.addressLine3,
              "Address Line 4": ele?.addressLine4,
              City: ele?.city,
              "Postal Code": ele?.pinCode ?? ele?.postalCode,
              "Region Description": ele?.regionalDescription,
              "Country Description": ele?.countryDescription,
              State: ele?.state,
            });
          });
        }
        // console.log("export Data", exportData);
        if (exportData?.length > 0) {
          exportToCSV([...exportData], "Locations");
        } else {
          exportData.push({
            "Address Line 1": "",
            "Address Line 2": "",
            "Address Line 3": "",
            "Address Line 4": "",
            City: "",
            "Postal Code": "",
            "Region Description": "",
            "Country Description": "",
            State: "",
          });
          exportToCSV([...exportData], "Locations");
        }
      }
    );
  };

  render() {
    // let userLang = JSON.parse(window.localStorage.getItem("userLangDetail"));
    let mode = localStorage.getItem("Theme")
      ? localStorage.getItem("Theme")
      : null;
    darkTheme = mode === "dark__mode" ? true : false;
    // const { name, phoneNo, loading } = this.state;
    const { getLocationsData } = this.props;
    const localStorageData = JSON.parse(localStorage.getItem("LocationsData"));
    const locationData = navigator.onLine
      ? getLocationsData?.data?.docs
      : localStorageData?.data?.docs;
    let rows = [];
    if (Array.isArray(locationData)) {
      // console.log("drivers : ", this.props.drivers.drivers.data.docs);
      totCnt = navigator.onLine
        ? getLocationsData?.data?.length
        : localStorageData?.data?.length;
      fromVal = totCnt !== 0 ? offset + 1 : fromVal;
      toVal = navigator.onLine
        ? getLocationsData?.data?.offset + getLocationsData?.data?.docs?.length
        : localStorageData?.data?.offset + localStorageData?.data?.length;
      totPages = Math.ceil(totCnt / process.env.REACT_APP_PERPAGE);
      locationData.forEach((ele) => {
        rows.push({
          locationId: ele?._id,
          locationName: ele?.locationName,
          description: ele?.description,
          addressLine1: ele?.addressLine1,
          addressLine2: ele?.addressLine2,
          addressLine3: ele?.addressLine3,
          addressLine4: ele?.addressLine4,
          city: ele?.city,
          postalCode: ele?.pinCode ?? ele?.postalCode,
          state: ele?.state,
          region: ele?.countryDescription,
          regionalDescription: ele?.regionalDescription,
        });
      });
    }
    return (
      <>
        <Modal
          isOpen={this.state.isOpen}
          toggle={this.closeModal}
          size="lg"
          className="locationModal"
        >
          <ModalHeader>
            <div className="Heading">
              <h3>Upload Locations Data</h3>
              <svg
                onClick={this.closeModal}
                width="15"
                height="15"
                viewBox="0 0 15 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.9092 1.82141L1.90918 13.8214"
                  stroke="#2800FC"
                  strokeWidth="4"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M1.90918 1.82141L13.9092 13.8214"
                  stroke="#2800FC"
                  strokeWidth="4"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </ModalHeader>
          <ModalBody>
            {this.state.loadingForExcel ? (
              <div
                style={{
                  height: "200px",
                }}
              >
                <WaveLoader />
              </div>
            ) : (
              <div className="imageDiv">
                <div className="d-block">
                  <svg
                    onClick={() => this.fileUploadTrigger()}
                    width="150"
                    height="150"
                    viewBox="0 0 50 50"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0 31.6534C0.0758962 31.2107 0.126494 30.768 0.227689 30.3253C0.809559 27.6309 2.23894 25.5185 4.51582 23.9753C4.65497 23.8741 4.80676 23.7729 4.9712 23.659C4.17429 20.9521 4.57907 18.4855 6.60297 16.4616C8.61422 14.4503 11.0808 13.9949 13.7372 14.8045C17.0893 8.92253 22.0225 6.15232 28.7773 7.22752C33.9256 8.04973 39.1245 12.4517 39.9214 19.3709C40.2376 19.4468 40.5665 19.4974 40.8827 19.5986C44.8167 20.7876 47.511 23.3428 48.8265 27.2009C50.6607 32.5515 48.7633 37.9781 44.0704 41.1531C42.2995 42.3548 40.3262 42.9873 38.1631 42.9873C35.0008 42.9873 31.8511 42.9873 28.6888 42.9873C28.499 42.9873 28.3093 42.9873 28.0942 42.9873C28.0942 39.3949 28.0942 35.8657 28.0942 32.2733C28.2587 32.2606 28.4105 32.248 28.5623 32.248C29.4351 32.248 30.3079 32.2353 31.168 32.248C31.7246 32.2606 32.2432 32.2227 32.5342 31.6534C32.8378 31.0842 32.5595 30.6415 32.2306 30.1988C31.0415 28.5543 29.8525 26.9099 28.6635 25.2655C27.7021 23.9373 26.7408 22.5965 25.7794 21.2683C25.1343 20.3829 24.35 20.3702 23.7176 21.2683C21.5419 24.2662 19.3788 27.2768 17.2031 30.2747C17.1525 30.3379 17.1146 30.4012 17.064 30.4771C16.811 30.8565 16.7351 31.2487 16.9501 31.6661C17.1652 32.0709 17.5194 32.2606 17.9874 32.2606C19.1132 32.2606 20.239 32.2606 21.4027 32.2606C21.4027 35.853 21.4027 39.3949 21.4027 42.9999C21.2003 42.9999 21.0106 42.9999 20.8209 42.9999C17.3043 42.9999 13.7878 42.9873 10.2839 42.9999C6.78006 43.0126 4.11104 41.4314 2.0745 38.6865C0.974001 37.1939 0.328883 35.5115 0.0885456 33.6647C0.0758962 33.5761 0.0252987 33.4876 0 33.3991C0 32.8172 0 32.2353 0 31.6534Z"
                      fill="#C6C6C6"
                    />
                  </svg>
                  <input
                    type="file"
                    name="Image"
                    multiple={true}
                    accept=".xlsx"
                    style={{ display: "none" }}
                    ref={this.fileInput}
                    onChange={(e) => {
                      this.fileUpload(e);
                    }}
                  />
                  <span className="clickText">
                    {this.state.selectedFile?.name
                      ? this.state.selectedFile?.name
                      : "Click here to upload Excel"}
                  </span>
                </div>
              </div>
            )}
          </ModalBody>
          <ModalFooter>
            <button
              className="uploadTemplateButton"
              onClick={() => {
                this.handledownloadTemplate();
              }}
            >
              <span className="light__span">
                <i
                  className="fas fa-file-excel"
                  style={{ color: "#20511f" }}
                ></i>
                &nbsp;Template
              </span>
              <GetAppIcon fontSize="xs" className="downloadIcon" />
            </button>
            <button
              className="Submit"
              onClick={() => {
                this.handleSubmitExcel();
              }}
            >
              Submit
            </button>
          </ModalFooter>
        </Modal>
        {getLocalStorage()}
        <QuickFilters
          openModal={this.openModal}
          toggleExcel={this.exportExcelData}
        />
        <div className="productList">
          <Index
            {...this.props}
            headers={AdminHeaderData}
            data={rows}
            searchable={true}
            searchBar={searchBar}
            reset={this.reset}
            searchValueAssignerFunction={this.searchValueAssignerFunction}
            // fetchId={this.props.fetchId}
            getAllData={this.getAllData}
            dataLength={getLocationsData?.data?.length}
            rowHeight={"56px"}
            classList="3"
            dataLoading={this.state.dataLoading}
            resetCol="9"
            filterMaintain={"off"}
          />
        </div>
        {totCnt !== 0 && !this.state.dataLoading ? (
          <Row
            xs={12}
            style={{ color: darkTheme ? "#9d9d9d" : "#0C0C0C" }}
            className="mb-2 paginationRow"
          >
            <Col xs={7} sm={5} md={4} className="span-col-pagenation">
              <div className="float-left">
                <Pagination
                  className="desktop-pagination"
                  size="medium"
                  shape="rounded"
                  page={offset / 10 + 1}
                  count={totPages}
                  color="primary"
                  onChange={this.handleChangePage}
                  defaultPage={1}
                  siblingCount={1}
                />
                <Pagination
                  className="mobile-pagination"
                  size="small"
                  shape="rounded"
                  page={offset / 10 + 1}
                  count={totPages}
                  color="primary"
                  onChange={this.handleChangePage}
                  defaultPage={1}
                  siblingCount={1}
                />
              </div>
            </Col>
            <Col
              className="mt-2 spanPagenationentries span-col-pagenation"
              xs={5}
              sm={7}
              md={8}
            >
              {" "}
              <span>
                Showing {fromVal} to {toVal} of {totCnt} entries
              </span>
            </Col>
          </Row>
        ) : null}
      </>
    );
  }
}
const mapStateToProps = (state) => {
  // console.log("state", state);

  return {
    ...state,
    getLocationsData: state?.locationReducer?.getLocationDetails,
  };
};
export default connect(mapStateToProps, {
  getLocations,
  getLocationsExcel,
  fetchLocationPresignedUrl,
  uploadImagesAws,
  createLocationViaExcel,
})(Location);
